// Generated automatically before every production build.
export const APP_BUILD_VERSION = "20261025-174822Z";
export const APP_BUILD_AT = "2026-10-25T17:48:22.778Z";
